import { format, parseISO } from "date-fns";
import { z } from "zod";

const ISO_DATE_FORMAT = "yyyy-MM-dd";

export const isoDateSchema = z.iso.date().brand<"IsoDateString">();
export type IsoDateString = z.infer<typeof isoDateSchema>;

export const isoDateCodec = z.codec(z.date(), isoDateSchema, {
  decode: (date) => isoDateSchema.parse(format(date, ISO_DATE_FORMAT)),
  encode: (iso) => parseISO(iso),
});
